import Dialog from '../modules/dialog.inc';
import { post } from 'axios';

let offerButton = document.querySelector('#send-quote');
if (offerButton) {
    offerButton.addEventListener('click', e => {
        e.preventDefault();
        offerButton.setAttribute('disabled', true);

        let offerBox = document.querySelector('[name=offer]');
        let emailBox = document.querySelector('[name=email]');

        if(offerBox.value == '' || emailBox.value == '') {
            new Dialog('Please make sure the offer and e-mail boxes are filled.').open();
            offerButton.removeAttribute('disabled');
            return false;
        }
        
        let emailRe = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
        if(!emailRe.test(String(emailBox.value).toLowerCase())) {
            new Dialog('Your e-mail address does not match a standard format.  Please check.').open();
            offerButton.removeAttribute('disabled');
            return false;
        }

        post('/api/gallery/offer', {
            artwork: document.querySelector('[name=artworkID]').value,
            offer: offerBox.value,
            email: emailBox.value
        }).then(() => {
            new Dialog('Your quote has been sent.  Please wait for a reply from us within a few days.').open();
        }).catch(err => {
            new Dialog('Sorry, we ran into a problem.  Please try e-mailing us your request.').open();
            offerButton.removeAttribute('disabled');
            throw err;
        });
    });
}